import React, { useCallback, useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import Header from '../../../components/Header/Header';
import './Edd.css';
import Edder from '../../../components/edd/Edder/Edder';
import FileNameModal from '../../../components/edd/FileNameModal/FileNameModal';
import EddFilesTable, { classNames } from '../../../components/edd/EddFilesTable/EddFilesTable';
import Spinner from '../../../components/Spinner/Spinner';
import FullPageLoader from '../../../components/edd/FullPageLoader/FullPageLoader';
import ConfirmModal from '../../../components/edd/ConfirmActions/ConfirmActions';
import Error from '../../../components/edd/Error/Error';
import {
  deleteFiles,
  downloadFiles,
  fetchFiles,
  filterFiles,
  importFiles,
  scheduleImport,
  uploadFiles,
  validateFiles,
  getLocalDateString,
  validateFileBeforeUpload,
  customDateHeader,
} from './EddUtils';
import HaveNoFiles from '../../../components/edd/HaveNoFiles/HaveNoFiles';
import 'font-awesome/css/font-awesome.min.css';
import ScheduleImport from '../../../components/edd/ScheduleImport/ScheduleImport';
import EddFilter from '../../../components/edd/EddFilter/EddFilter';
import EddSplashScreen from '../../../components/edd/EddSplashScreen/EddSplashScreen';
import { toggleFileType } from './fileManagerUtils';
import {
  clearFiltersHelper,
  fileTypeToggleHelper,
  filterSearchFieldChangeHelper,
  importStatusToggleHelper,
  importedDateFilterHelper,
  sortColumnChangeFilterHelper,
  sortOrderChangeFilterHelper,
  uploadedDateFilterHelper,
  validationStatusFilterToggleHelper,
} from '../../../components/edd/EddFilter/ComponentFilteringUtils';
import {
  parseUrlFilters,
  applyUrlFiltersToState,
  buildFilterUrl as buildFilterUrlFromState,
  scheduleImportHelper,
  scheduleClickedHelper,
  downloadClickedHelper,
  validateClickedHelper,
  importClickedHelper,
  deleteClickedHelper,
  downloadProceedHelper,
  validateProceedHelper,
  importProceedHelper,
  deleteProceedHelper,
  addFileHelper,
  inputChangeHelper,
  fetchPageHelper,
  itemCheckedHelper,
  fileNameChecboxChangedHelper,
} from './PropDrillerUtils';
import { DEFAULT_ITEMS_PER_PAGE } from '../../Pagination/Pagination';
import qs from '../../../utils/qs';
import { removeQueryParam } from '../../../utils/updateQueryString';

function Edd({ history, location }) {
  const [filesRetrieved, setFilesRetrieved] = useState([]);
  const [filesSelected, setFilesSelected] = useState([]);
  const [showFileNameModal, setShowFileNameModal] = useState(false);
  const [filesToUpload, setFilesToUpload] = useState([]);
  const [fileToUploadNames, setFileToUploadNames] = useState(new Array(30).fill(''));
  const [filesSelecting, setFilesSelecting] = useState(false);
  const [fullPageLoading, setFullPageLoading] = useState(false);
  const [fullPageLoadingTitle, setFullPageLoadingTitle] = useState('');
  const [totalNumberOfRows, setTotalNumberOfRows] = useState(0);
  const [shiftLastIndex, setShiftLastIndex] = useState(false);
  const [confirmModalData, setConfirmModalData] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showConfirmModalTitle, setShowConfirmModalTitle] = useState('');
  const [showConfirmModalSubtitle, setShowConfirmModalSubtitle] = useState('');
  const [confirmModalOnClick, setConfirmModalOnClick] = useState(() => () => {});
  const [confirmModalBtnText, setConfirmModalBtnText] = useState('Submit');
  const [showFilter, setShowFilter] = useState(false);
  const [playlistFilter, setPlaylistFilter] = useState(false);
  const [sequenceFilter, setSequenceFilter] = useState(false);
  const [scheduleFilter, setScheduleFilter] = useState(false);
  const [assignmentFilter, setAssignmentFilter] = useState(false);
  const [tagFilter, setTagFilter] = useState(false);
  const [sortOrderFilter, setSortOrderFilter] = useState();
  const [sortColumnFilter, setSortColumnFilter] = useState();
  const [fileTypeFilter, setFileTypeFilter] = useState([]);
  const [validStatusFilter, setValidStatusFilter] = useState(false);
  const [invalidStatusFilter, setInvalidStatusFilter] = useState(false);
  const [validationStatusTypeFilter, setValidationStatusTypeFilter] = useState([]);
  const [filterSearchField, setFilterSearchField] = useState('');
  const [importStatusTypeFilter, setImportStatusTypeFilter] = useState([]);
  const [importedStatusFilter, setImportedStatusFilter] = useState(false);
  const [notImportedStatusFilter, setNotImportedStatusFilter] = useState(false);
  const [scheduledForImportStatusFilter, setScheduledForImportStatusFilter] = useState(false);
  const [uploadedDateFilter, setUploadedDateFilter] = useState(null);
  const [importedDateFilter, setImportedDateFilter] = useState(null);
  const [showScheduleImport, setShowScheduleImport] = useState(null);
  const [scheduleImportData, setScheduleImportData] = useState([]);
  const [errorTitle, setErrorTitle] = useState('');
  const [errorDescription, setErrorDescription] = useState('');
  const [showError, setShowError] = useState(false);
  const [errorAction] = useState(() => () => {});
  const [filterLoading, setFilterLoading] = useState(false);
  const [noSearchResults, setNoSearchResults] = useState(false);
  const [showSplashPopup, setShowSplashPopup] = useState(0);
  const skipNextFetch = useRef(false);
  const isInitialMount = useRef(true);
  const filesPerPage = Number.parseInt(qs({ location }).count, 10) || DEFAULT_ITEMS_PER_PAGE;
  const buildFilterUrl = useCallback(
    (overrides = {}) =>
      buildFilterUrlFromState({
        overrides,
        fileTypeFilter,
        validationStatusTypeFilter,
        importStatusTypeFilter,
        filterSearchField,
        sortOrderFilter,
        sortColumnFilter,
        uploadedDateFilter,
        importedDateFilter,
        pathname: location.pathname,
        count: qs({ location }).count,
        getLocalDateString,
      }),
    [
      fileTypeFilter,
      validationStatusTypeFilter,
      importStatusTypeFilter,
      filterSearchField,
      sortOrderFilter,
      sortColumnFilter,
      uploadedDateFilter,
      importedDateFilter,
      location,
    ],
  );
  const fetchPageCommonArgs = {
    setFilesRetrieved,
    setTotalNumberOfRows,
    setErrorTitle,
    setErrorDescription,
    setShowError,
    filterFiles,
    fetchFiles,
    getLocalDateString,
    setNoSearchResults,
  };

  const syncFiltersFromUrl = loc => {
    const {
      count,
      page,
      hasFilters,
      fileTypes,
      validationStatuses,
      importStatuses,
      search,
      sortOrder,
      sortColumn,
      uploadedDate,
      importedDate,
    } = parseUrlFilters(qs({ location: loc }), DEFAULT_ITEMS_PER_PAGE);

    applyUrlFiltersToState({
      fileTypes,
      validationStatuses,
      importStatuses,
      search,
      sortOrder,
      sortColumn,
      uploadedDate,
      importedDate,
      setFileTypeFilter,
      setPlaylistFilter,
      setSequenceFilter,
      setScheduleFilter,
      setAssignmentFilter,
      setTagFilter,
      setValidationStatusTypeFilter,
      setValidStatusFilter,
      setInvalidStatusFilter,
      setImportStatusTypeFilter,
      setImportedStatusFilter,
      setNotImportedStatusFilter,
      setScheduledForImportStatusFilter,
      setFilterSearchField,
      setSortOrderFilter,
      setSortColumnFilter,
      setUploadedDateFilter,
      setImportedDateFilter,
    });

    return {
      count,
      page,
      hasFilters,
      fileTypeFilter: fileTypes,
      validationStatusTypeFilter: validationStatuses,
      importStatusTypeFilter: importStatuses,
      filterSearchField: search,
      sortOrderFilter: sortOrder || null,
      sortColumnFilter: sortColumn || null,
      uploadedDateFilter: uploadedDate,
      importedDateFilter: importedDate,
    };
  };

  const resetToFirstPage = useCallback(async () => {
    skipNextFetch.current = true;
    const { offset } = qs({ location });

    if (offset) {
      removeQueryParam(history, location, 'offset', offset);
    }

    await fetchPageHelper({
      fileTypeFilter,
      validationStatusTypeFilter,
      importStatusTypeFilter,
      filterSearchField,
      uploadedDateFilter,
      importedDateFilter,
      sortColumnFilter,
      sortOrderFilter,
      limit: filesPerPage,
      page: 1,
      ...fetchPageCommonArgs,
    });

    setFullPageLoading(false);
  }, [
    location,
    history,
    fileTypeFilter,
    validationStatusTypeFilter,
    importStatusTypeFilter,
    filterSearchField,
    uploadedDateFilter,
    importedDateFilter,
    sortColumnFilter,
    sortOrderFilter,
    filesPerPage,
  ]);

  useEffect(() => {
    const { count, page, hasFilters, ...filterArgs } = syncFiltersFromUrl(location);

    setFullPageLoading(true);
    setFullPageLoadingTitle('Fetching Files');
    fetchPageHelper({
      ...filterArgs,
      limit: count,
      page,
      hasFilters,
      ...fetchPageCommonArgs,
      setShowSplashPopup,
    })
      .then(() => {
        setFullPageLoading(false);
        setFullPageLoadingTitle('');
      })
      .catch(() => {
        setFullPageLoading(false);
        setFullPageLoadingTitle('');
      });
  }, []);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;

      return;
    }

    if (skipNextFetch.current) {
      skipNextFetch.current = false;

      return;
    }

    const { count, page, hasFilters, ...filterArgs } = syncFiltersFromUrl(location);

    setFilterLoading(true);
    fetchPageHelper({
      ...filterArgs,
      limit: count,
      page,
      hasFilters,
      ...fetchPageCommonArgs,
    })
      .then(() => setFilterLoading(false))
      .catch(() => setFilterLoading(false));
  }, [location.search]);

  useEffect(() => {
    const noFilesSelected = filesRetrieved.filter(el => el.selected);

    setFilesSelected(noFilesSelected);
  }, [filesRetrieved]);

  const handleItemChecked = useCallback(
    (event, i) => {
      itemCheckedHelper({
        event,
        index: i,
        filesRetrieved,
        setFilesRetrieved,
        shiftLastIndex,
        setShiftLastIndex,
      });
    },
    [filesRetrieved, shiftLastIndex],
  );
  const handleInputChange = useCallback(
    async e => {
      await inputChangeHelper({
        filesEvent: e,
        filesRetrieved,
        setFilesToUpload,
        setFileToUploadNames,
        setFullPageLoading,
        setFullPageLoadingTitle,
        setShowFileNameModal,
        setErrorTitle,
        setErrorDescription,
        setShowError,
        setFilesSelecting,
        uploadFiles,
        validateFileBeforeUpload,
        setTotalNumberOfRows,
        setFilesRetrieved,
      });
    },
    [filesRetrieved],
  );
  const handleFileNameModifyChecked = useCallback(
    (e, i) => {
      fileNameChecboxChangedHelper({
        event: e,
        index: i,
        filesToUpload,
        fileToUploadNames,
        setFileToUploadNames,
      });
    },
    [fileToUploadNames, filesToUpload],
  );
  const handleFileNameModifyInputChanged = useCallback(
    (e, i) => {
      const value = e.target.value;
      const fileNames = [...fileToUploadNames];

      fileNames[i] = value;
      setFileToUploadNames(fileNames);
    },
    [fileToUploadNames],
  );
  const addFile = useCallback(async () => {
    await addFileHelper({
      filesToUpload,
      fileToUploadNames,
      filesRetrieved,
      setFullPageLoading,
      setFullPageLoadingTitle,
      setShowFileNameModal,
      setFilesToUpload,
      setFileToUploadNames,
      setErrorTitle,
      setErrorDescription,
      setShowError,
      resetToFirstPage,
      uploadFiles,
    });
  }, [fileToUploadNames, filesToUpload, resetToFirstPage]);
  const deleteProceed = useCallback(async () => {
    await deleteProceedHelper({
      filesSelected,
      filesRetrieved,
      setShowConfirmModal,
      setFullPageLoading,
      setFullPageLoadingTitle,
      setFilesSelected,
      setErrorTitle,
      setErrorDescription,
      setShowError,
      resetToFirstPage,
      deleteFiles,
    });
  }, [filesSelected, filesRetrieved, resetToFirstPage]);
  const importProceed = useCallback(async () => {
    await importProceedHelper({
      filesSelected,
      setShowConfirmModal,
      setFullPageLoading,
      setFullPageLoadingTitle,
      setFilesSelected,
      setErrorTitle,
      setErrorDescription,
      setShowError,
      resetToFirstPage,
      importFiles,
    });
  }, [filesSelected, resetToFirstPage]);
  const validateProceed = useCallback(async () => {
    await validateProceedHelper({
      filesSelected,
      setShowConfirmModal,
      setFullPageLoading,
      setFullPageLoadingTitle,
      setFilesSelected,
      setErrorTitle,
      setErrorDescription,
      setShowError,
      resetToFirstPage,
      validateFiles,
    });
  }, [filesSelected, resetToFirstPage]);
  const downloadProceed = useCallback(async () => {
    await downloadProceedHelper({
      filesSelected,
      filesRetrieved,
      setShowConfirmModal,
      setFullPageLoading,
      setFullPageLoadingTitle,
      setFilesSelected,
      setFilesRetrieved,
      setErrorTitle,
      setErrorDescription,
      setShowError,
      downloadFiles,
    });
  }, [filesSelected, filesRetrieved]);
  const confirmModalSetters = {
    setErrorTitle,
    setErrorDescription,
    setShowError,
    setShowConfirmModal,
    setShowConfirmModalTitle,
    setShowConfirmModalSubtitle,
    setConfirmModalData,
    setConfirmModalOnClick,
    setConfirmModalBtnText,
  };
  const deleteClicked = useCallback(() => {
    deleteClickedHelper({ filesSelected, ...confirmModalSetters, deleteProceed });
  }, [filesSelected]);
  const importClicked = useCallback(() => {
    importClickedHelper({ filesSelected, ...confirmModalSetters, importProceed });
  }, [filesSelected]);
  const validateClicked = useCallback(() => {
    validateClickedHelper({ filesSelected, ...confirmModalSetters, validateProceed });
  }, [filesSelected]);
  const downloadClicked = useCallback(() => {
    downloadClickedHelper({ filesSelected, ...confirmModalSetters, downloadProceed });
  }, [filesSelected]);

  const handleFilterToggle = () => {
    setShowFilter(!showFilter);
  };

  const handleFileTypeChange = async type => {
    const newFileTypes = fileTypeFilter.includes(type)
      ? fileTypeFilter.filter(t => t !== type)
      : [...fileTypeFilter, type];
    const newUrl = buildFilterUrl({ fileTypes: newFileTypes });

    await fileTypeToggleHelper({
      type,
      fileTypeFilter,
      playlistFilter,
      setPlaylistFilter,
      sequenceFilter,
      setSequenceFilter,
      scheduleFilter,
      setScheduleFilter,
      assignmentFilter,
      setAssignmentFilter,
      tagFilter,
      setTagFilter,
      validationStatusTypeFilter,
      filterSearchField,
      importStatusTypeFilter,
      uploadedDateFilter,
      importedDateFilter,
      sortOrderFilter,
      sortColumnFilter,
      filesPerPage,
      setFileTypeFilter,
      setNoSearchResults,
      setFilesRetrieved,
      setTotalNumberOfRows,
      setFilterLoading,
      filterFiles,
      getLocalDateString,
      toggleFileType,
    });
    skipNextFetch.current = true;
    history.push(newUrl);
  };

  const handleSortOrderChangeFilter = async sortOrderValue => {
    const newUrl = buildFilterUrl({ sortOrder: sortOrderValue });

    await sortOrderChangeFilterHelper({
      sortOrderValue,
      fileTypeFilter,
      validationStatusTypeFilter,
      filterSearchField,
      importStatusTypeFilter,
      uploadedDateFilter,
      importedDateFilter,
      sortColumnFilter,
      filesPerPage,
      setSortOrderFilter,
      setNoSearchResults,
      setFilesRetrieved,
      setTotalNumberOfRows,
      setFilterLoading,
      filterFiles,
      getLocalDateString,
    });
    skipNextFetch.current = true;
    history.push(newUrl);
  };

  const handleSortColumnChangeFilter = async sortColumn => {
    const newUrl = buildFilterUrl({ sortColumn });

    await sortColumnChangeFilterHelper({
      sortColumn,
      fileTypeFilter,
      validationStatusTypeFilter,
      filterSearchField,
      importStatusTypeFilter,
      uploadedDateFilter,
      importedDateFilter,
      sortOrderFilter,
      filesPerPage,
      setSortColumnFilter,
      setNoSearchResults,
      setFilesRetrieved,
      setTotalNumberOfRows,
      setFilterLoading,
      filterFiles,
      getLocalDateString,
    });
    skipNextFetch.current = true;
    history.push(newUrl);
  };

  const handleValidationStatusFilterChange = async type => {
    const newValidationStatuses = validationStatusTypeFilter.includes(type)
      ? validationStatusTypeFilter.filter(s => s !== type)
      : [...validationStatusTypeFilter, type];
    const newUrl = buildFilterUrl({ validationStatuses: newValidationStatuses });

    await validationStatusFilterToggleHelper({
      type,
      validationStatusTypeFilter,
      validStatusFilter,
      setValidStatusFilter,
      invalidStatusFilter,
      setInvalidStatusFilter,
      setValidationStatusTypeFilter,
      fileTypeFilter,
      filterSearchField,
      importStatusTypeFilter,
      uploadedDateFilter,
      importedDateFilter,
      sortOrderFilter,
      sortColumnFilter,
      filesPerPage,
      setNoSearchResults,
      setFilesRetrieved,
      setTotalNumberOfRows,
      setFilterLoading,
      filterFiles,
      getLocalDateString,
    });
    skipNextFetch.current = true;
    history.push(newUrl);
  };

  const handleImportStatusFilterChange = async type => {
    const newImportStatuses = importStatusTypeFilter.includes(type)
      ? importStatusTypeFilter.filter(s => s !== type)
      : [...importStatusTypeFilter, type];
    const newUrl = buildFilterUrl({ importStatuses: newImportStatuses });

    await importStatusToggleHelper({
      type,
      importStatusTypeFilter,
      importedStatusFilter,
      setImportedStatusFilter,
      notImportedStatusFilter,
      setNotImportedStatusFilter,
      scheduledForImportStatusFilter,
      setScheduledForImportStatusFilter,
      setImportStatusTypeFilter,
      fileTypeFilter,
      validationStatusTypeFilter,
      filterSearchField,
      uploadedDateFilter,
      importedDateFilter,
      sortOrderFilter,
      sortColumnFilter,
      filesPerPage,
      setNoSearchResults,
      setFilesRetrieved,
      setTotalNumberOfRows,
      setFilterLoading,
      filterFiles,
      getLocalDateString,
    });
    skipNextFetch.current = true;
    history.push(newUrl);
  };

  const handleFilterSearchFieldChange = async e => {
    const searchValue = e.target.value;
    const newUrl = buildFilterUrl({ search: searchValue });

    await filterSearchFieldChangeHelper({
      searchValue,
      fileTypeFilter,
      validationStatusTypeFilter,
      importStatusTypeFilter,
      uploadedDateFilter,
      importedDateFilter,
      sortOrderFilter,
      sortColumnFilter,
      filesPerPage,
      setFilterSearchField,
      setNoSearchResults,
      setFilesRetrieved,
      setTotalNumberOfRows,
      setFilterLoading,
      filterFiles,
      getLocalDateString,
    });
    skipNextFetch.current = true;
    history.push(newUrl);
  };

  const handleUploadDateFilterChanged = async newDate => {
    const newUrl = buildFilterUrl({ uploadedDate: newDate });

    await uploadedDateFilterHelper({
      newDate,
      fileTypeFilter,
      validationStatusTypeFilter,
      filterSearchField,
      importStatusTypeFilter,
      importedDateFilter,
      sortOrderFilter,
      sortColumnFilter,
      filesPerPage,
      setUploadedDateFilter,
      setNoSearchResults,
      setFilesRetrieved,
      setTotalNumberOfRows,
      setFilterLoading,
      filterFiles,
      getLocalDateString,
    });
    skipNextFetch.current = true;
    history.push(newUrl);
  };

  const handleImportDateFilterChanged = async newDate => {
    const newUrl = buildFilterUrl({ importedDate: newDate });

    await importedDateFilterHelper({
      newDate,
      fileTypeFilter,
      validationStatusTypeFilter,
      filterSearchField,
      importStatusTypeFilter,
      uploadedDateFilter,
      sortOrderFilter,
      sortColumnFilter,
      filesPerPage,
      setImportedDateFilter,
      setNoSearchResults,
      setFilesRetrieved,
      setTotalNumberOfRows,
      setFilterLoading,
      filterFiles,
      getLocalDateString,
    });
    skipNextFetch.current = true;
    history.push(newUrl);
  };

  const handleClearFilters = async () => {
    const count = Number.parseInt(qs({ location }).count, 10);
    const cleanUrl = count ? `${location.pathname}?count=${count}` : location.pathname;

    await clearFiltersHelper({
      filesPerPage,
      setFilterLoading,
      setNoSearchResults,
      setImportedDateFilter,
      setUploadedDateFilter,
      setValidStatusFilter,
      setInvalidStatusFilter,
      setFilterSearchField,
      setPlaylistFilter,
      setScheduleFilter,
      setSequenceFilter,
      setAssignmentFilter,
      setTagFilter,
      setSortColumnFilter,
      setSortOrderFilter,
      setValidationStatusTypeFilter,
      setImportStatusTypeFilter,
      setImportedStatusFilter,
      setNotImportedStatusFilter,
      setScheduledForImportStatusFilter,
      setFileTypeFilter,
      setFilesRetrieved,
      setTotalNumberOfRows,
      handleFilterToggle,
      setErrorTitle,
      setErrorDescription,
      setShowError,
      fetchFiles,
    });

    skipNextFetch.current = true;
    history.push(cleanUrl);
  };

  const scheduleClicked = async () => {
    scheduleClickedHelper({
      filesSelected,
      setErrorTitle,
      setErrorDescription,
      setShowError,
      setScheduleImportData,
      setShowScheduleImport,
    });
  };

  const handleScheduleImport = async (importDates, setDateArr) => {
    await scheduleImportHelper({
      filesSelected,
      importDates,
      setShowScheduleImport,
      setFullPageLoading,
      setFullPageLoadingTitle,
      setScheduleImportData,
      setDateArr,
      setFilesSelected,
      setErrorTitle,
      setErrorDescription,
      setShowError,
      resetToFirstPage,
      scheduleImport,
    });
  };

  return (
    <div className="page-edd custom-page tailwind-container min-h-screen z-40 h-full bg-[#EFF5F8]">
      <Helmet title="Edd" />
      <Header file />
      <Edder
        handleFilterToggle={handleFilterToggle}
        handleInputChange={handleInputChange}
        filesSelecting={filesSelecting}
        setFilesSelecting={setFilesSelecting}
        filesSelected={filesSelected}
        deleteClicked={deleteClicked}
        importClicked={importClicked}
        validateClicked={validateClicked}
        downloadClicked={downloadClicked}
        scheduleClicked={scheduleClicked}
        showJointActions={filesRetrieved.length > 0}
      />
      <div
        className={classNames(
          'bg-white rounded-[15px] mt-4  border-box',
          filesRetrieved.length > 0 ? 'min-h-screen p-2' : '',
        )}
      >
        <ConfirmModal
          setShowConfirmModal={setShowConfirmModal}
          show={showConfirmModal}
          data={confirmModalData}
          title={showConfirmModalTitle}
          onClick={confirmModalOnClick}
          subtitle={showConfirmModalSubtitle}
          confirmModalBtnText={confirmModalBtnText}
        />

        <FullPageLoader title={fullPageLoadingTitle} loading={fullPageLoading} />
        <EddSplashScreen show={showSplashPopup} setShowSplashPopup={setShowSplashPopup} />
        <ScheduleImport
          setShowScheduleImport={setShowScheduleImport}
          show={showScheduleImport}
          setShowConfirmModal={setShowConfirmModal}
          data={scheduleImportData}
          title="Schedule Import"
          onClick={() => {}}
          handleScheduleImport={handleScheduleImport}
          subtitle="When would you like to import these files?"
          scheduleImportButtonText="Set Import Date"
        />
        <FileNameModal
          showFileNameModal={showFileNameModal}
          files={filesToUpload}
          setShowFileNameModal={setShowFileNameModal}
          fileNames={fileToUploadNames}
          handleFileNameModifyChecked={handleFileNameModifyChecked}
          setFullPageLoading={setFullPageLoading}
          handleFileNameModifyInputChanged={handleFileNameModifyInputChanged}
          setFullPageLoadingTitle={setFullPageLoadingTitle}
          submitAction={addFile}
        />

        <Error
          title={errorTitle}
          description={errorDescription}
          show={showError}
          setShowError={setShowError}
          errorAction={errorAction}
        />

        {filesRetrieved.length > 0 ? (
          <>
            {' '}
            <Spinner />
            <div className="relative flex">
              <EddFilter
                handleSortColumnChangeFilter={handleSortColumnChangeFilter}
                handleSortOrderChangeFilter={handleSortOrderChangeFilter}
                sortOrderFilter={sortOrderFilter}
                sortColumnFilter={sortColumnFilter}
                showFilter={showFilter}
                filterSearchField={filterSearchField}
                handleFilterSearchFieldChange={handleFilterSearchFieldChange}
                playlistFilter={playlistFilter}
                handleFileTypeChange={handleFileTypeChange}
                sequenceFilter={sequenceFilter}
                scheduleFilter={scheduleFilter}
                assignmentFilter={assignmentFilter}
                tagFilter={tagFilter}
                validStatusFilter={validStatusFilter}
                handleValidationStatusFilterChange={handleValidationStatusFilterChange}
                invalidStatusFilter={invalidStatusFilter}
                importedStatusFilter={importedStatusFilter}
                handleImportStatusFilterChange={handleImportStatusFilterChange}
                scheduledForImportStatusFilter={scheduledForImportStatusFilter}
                uploadedDateFilter={uploadedDateFilter}
                notImportedStatusFilter={notImportedStatusFilter}
                handleUploadDateFilterChanged={handleUploadDateFilterChanged}
                customDateHeader={customDateHeader}
                handleClearFilters={handleClearFilters}
                importedDateFilter={importedDateFilter}
                handleImportDateFilterChanged={handleImportDateFilterChanged}
              />

              <div
                className={classNames(
                  'transition-all duration-1000 resizable-element',
                  showFilter ? 'w-[80%] translate-x-[288px]' : 'w-full translate-x-0',
                )}
              >
                {noSearchResults ? (
                  <div className="bg-white z-30 text-lg text-dark-night rounded-md h-32 shadow-lg border ml-8 mr-8 flex items-center justify-center text-sm mt-16">
                    <p>No Search results found</p>
                  </div>
                ) : (
                  <EddFilesTable
                    handleFilterToggle={handleFilterToggle}
                    handleItemChecked={handleItemChecked}
                    filesRetrieved={filesRetrieved}
                    totalNumberOfRows={totalNumberOfRows}
                    filterLoading={filterLoading}
                  />
                )}
              </div>
            </div>
          </>
        ) : (
          <HaveNoFiles
            handleInputChange={handleInputChange}
            filesSelecting={filesSelecting}
            setFilesSelecting={setFilesSelecting}
          />
        )}
      </div>
    </div>
  );
}

Edd.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default withRouter(Edd);
